import { get, post, remove } from "./base";

export function getWellTop(wellIds, onSuccess, onError) {
  get(
    "/api/tops/editor/",
    { well_uwis: wellIds.join(",") },
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      onError(error);
    }
  );
}

export function saveWellTop(wells, onSuccess, onError) {
  post(
    "/api/tops/editor/",
    wells,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      onError(error);
    },
    true
  );
}

export function removeWellTop(params, onSuccess, onError) {
  remove(
    "/api/tops/editor/",
    params,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    onError
  );
}

export function getWellTopDict(params, onSuccess, onError) {
  get(
    "/api/tops/dict/",
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    onError
  );
}